import * as AuthenticationActions from '~/ducks/authentication/actions';
import { setServerMaintenanceActive } from '~/ducks/server-maintenance/reducer';
import { ServerMaintenanceRedirectException } from '~/utils/fetch-wrapper/errors';
import ErrorConstants from '~/components/containers/UnhandledErrorContainer/constants';
import { mutex } from '~/domain/auth/utils/auth-lock';
import appReducer, { AppState } from './index';

//https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store/35641992#35641992
const rootReducer = (state, action): AppState => {
  const { error, type, exception, payload } = action;
  const errorStatusCode = error && error.status ? error.status : false;
  const isLogoutAction = type === AuthenticationActions.clearUser.type;
  const isErrorMsgAction = type === ErrorConstants.ERROR;
  const isSessionExpired = errorStatusCode === 401 || payload?.status === 401;
  const isTokenRefreshInProgress = mutex.isLocked();
  if (exception instanceof ServerMaintenanceRedirectException) {
    action = setServerMaintenanceActive();
  } else if (
    isLogoutAction ||
    (isSessionExpired &&
      !isErrorMsgAction &&
      state.authentication.authenticated &&
      !isTokenRefreshInProgress)
  ) {
    //let first action to go through, to ensure failure action is run
    const { authentication, featureActive, ISIMCodeValidator, translation, router } = appReducer(
      state,
      action
    );

    //Set all stores to initial state when user is logging out (Don't reset translations or authentication)
    state = {
      authentication,
      featureActive,
      ISIMCodeValidator,
      translation,
      router,
      app: { isInitializingApp: false }, //on logout the app is already initialized.
    };

    if (isSessionExpired) {
      action = {
        type: AuthenticationActions.loginDIAM.failure,
        error: {
          status: 401,
          description: 'web.error.session_expired',
        },
      };
    }
  }

  return appReducer(state, action);
};

export default rootReducer;
